<template>
    <div v-can="'settings_sms_messages.access'">
        <vc-table :tableData="sms" stripe tHeader>
            <template v-slot:header>
                <vs-button v-can="'settings_sms_messages.create'" @click="create" class="mr-4 whitespace-no-wrap" color="primary" type="border" icon-pack="feather" icon="icon-plus">{{$t('modals.Create_message')}}</vs-button>
                <vs-button v-can:show="'settings_sms_messages.create'" disabled class="mr-4 whitespace-no-wrap" color="primary" type="border" icon-pack="feather" icon="icon-plus">{{$t('modals.Create_message')}}</vs-button>
            </template>

            <template v-slot:head>
                <vs-th sort-key="message">{{$t('global.message')}}</vs-th>
                <vs-th sort-key="language">{{$t('global.Language')}}</vs-th>
                <vs-th>{{$t('global.Actions')}}</vs-th>
            </template>

            <template v-slot:content="{content}">
                <vs-td>
                    <p class="product-name font-medium truncate">{{ content.message }}</p>
                </vs-td>
                <vs-td>
                    <p class="product-name font-medium truncate">{{ content.language }}</p>
                </vs-td>
                <vs-td>
                    <div class="flex">
                        <div class="mr-4">
                            <vs-button v-can="'settings_sms_messages.update'" @click.prevent="edit(content)" v-tooltip="$t('global.edit_message')" radius color="primary" type="flat" icon-pack="feather" icon="icon-edit"></vs-button>
                            <vs-button v-can:show="'settings_sms_messages.update'" disabled radius color="primary" type="flat" icon-pack="feather" icon="icon-edit"></vs-button>
                        </div>
                        <div>
                            <vs-button v-can="'settings_sms_messages.destroy'" @click.prevent="destroy(content.id)" v-tooltip="$t('global.remove_message')" radius color="primary" type="flat" icon-pack="feather" icon="icon-trash"></vs-button>
                            <vs-button v-can:show="'settings_sms_messages.destroy'" disabled radius color="primary" type="flat" icon-pack="feather" icon="icon-trash"></vs-button>
                        </div>
                    </div>
                </vs-td>
            </template>
        </vc-table>
    </div>
</template>

<script>
import EventBus from '@/store/eventBus'
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
export default {
    data() {
        return {
            smsList: [],
            messageId: null
        }
    },

    computed: {
        sms() {
            return this.smsList
        }
    },

    methods: {
        create() {
            EventBus.$emit('emitPopupEvent', {type: 'createMessageSms', name: this.$t('modals.Create_message')})
        },

        edit(data) {
            EventBus.$emit('emitPopupEvent', {type: 'updateMessageSms', name: this.$t('modals.Edit_message'), data})
        },

        destroy(id) {
            this.messageId = id
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: this.$t('confirm.deleteMessage'),
                accept: this.sendDestroy,
                acceptText: this.$t('buttons.Delete'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async sendDestroy() {
            try {
                await send(this.$url['sms-message'].delete, 'DELETE', {data: {id: this.messageId}})
                await this.getMessages()
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async getMessages() {
            try {
                this.smsList = await send(this.$url['sms-message'].get, 'GET').then(data => data.data.result)
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        await this.getMessages(),

        EventBus.$on('responseCreateSMSMessages', async () => {
            await this.getMessages()
        })
    }
}
</script>
